export default __webpack_public_path__ + "static/media/LondonParisBachelier-2025.71e9597f.pdf";